/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import loadingConfig from '@pages/NomineeKYCPage/config/loading.config.json';

export interface ILoadingContentPluginMethods extends IPluginMethodMap {
  getLoadingContentSync(args?: any): any;
}

export class LoadingContentPlugin implements IAgentPlugin {
  readonly methods: ILoadingContentPluginMethods;

  constructor() {
    this.methods = {
      getLoadingContentSync: this.getLoadingContentSync.bind(this),
    };
  }

  getLoadingContentSync(args?: any) {
    return {
      loading: loadingConfig,
    };
  }
}
